import { Input } from 'rsuite';
import { cssVars } from '@/app/styles';
import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 280px;
  min-height: 800px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  background-color: ${cssVars.helpNavColors.bg1};
`;

export const VerticalBar = styled.div`
  width: 280px;
  margin: 32px auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow-y: scroll;
`;

export const StyledInput = styled(Input)`
  width: 204px !important;
  height: 36px;
  margin-left: 37px;
  margin-top: 32px;
  border: solid 1px ${cssVars.helpNavColors.border};
  background-color: ${cssVars.helpNavColors.bg2};

  ::placeholder {
    font-size: 14px;
    letter-spacing: normal;
    color: ${cssVars.textColors.light3};
  }
`;

export const MainContentWrapper = styled.div`
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
  font-size: 14px;
  font-weight: 600;
  align-self: flex-start;
  color: ${cssVars.textColors.dark3};
`;

export const BulletedList = styled.ul`
  display: flex;
  flex-direction: column;
`;

export const ListItem = styled.li`
  padding: 10px 0px;
  cursor: pointer;
  color: ${(props) =>
    props.activeItem === props.header
      ? cssVars.color.rentalscapeBlue
      : cssVars.color.helpPageColor.textColor};
`;
